import {GritModel} from "./grit.model";
import Feature from "ol/Feature";
import {FeatureType} from "../../models/EnumTypes";
import {VectorLayerDMTR} from "../../menu/view-menu/layer";
import {Geometry} from "ol/geom";

export type GritFeatureOptions = {
  featureType : FeatureType,
  layer: VectorLayerDMTR,
  geometry : Geometry,
  entity: GritModel<any>
}

export class GritFeature<T extends GritModel<any>> extends Feature {
  constructor(id: number, options: GritFeatureOptions) {
    super(options);
    super.setId(id);
  }

  get featureType(): FeatureType {
    return super.get("featureType") as FeatureType
  }

  get entity(): T {
    return super.get("entity") as T
  }

  set entity(entity : T){
    super.set("entity", entity);
  }

  get layer(): VectorLayerDMTR {
    return super.get("layer") as VectorLayerDMTR
  }
}
